import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_AGING_REPORT_REQUEST = 'FETCH_AGING_REPORT_REQUEST';
export const FETCH_AGING_REPORT_SUCCESS = 'FETCH_AGING_REPORT_SUCCESS';
export const FETCH_AGING_REPORT_ERROR = 'FETCH_AGING_REPORT_ERROR';

export const FETCH_AGING_REPORT_DETAILS_REQUEST = 'FETCH_AGING_REPORT_DETAILS_REQUEST';
export const FETCH_AGING_REPORT_DETAILS_SUCCESS = 'FETCH_AGING_REPORT_DETAILS_SUCCESS';
export const FETCH_AGING_REPORT_DETAILS_ERROR = 'FETCH_AGING_REPORT_DETAILS_ERROR';

export const GENERATE_INVOICE_PDF_REQUEST = 'GENERATE_INVOICE_PDF_REQUEST';
export const GENERATE_INVOICE_PDF_SUCCESS = 'GENERATE_INVOICE_PDF_SUCCESS';
export const GENERATE_INVOICE_PDF_ERROR = 'GENERATE_INVOICE_PDF_ERROR';

export const fetchAgingReport = data => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [FETCH_AGING_REPORT_REQUEST, FETCH_AGING_REPORT_SUCCESS, FETCH_AGING_REPORT_ERROR],
        callAPI: () => ApiClient.post('payment/AgingReport', data),
        payload: { data },
      }),
    );
  };

  export const generateAgingSummaryPdf = data => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [FETCH_AGING_REPORT_REQUEST, FETCH_AGING_REPORT_SUCCESS, FETCH_AGING_REPORT_ERROR],
        callAPI: () => ApiClient.post('payment/AgingReport/AgingReportSummaryPDF', data),
        payload: { data },
      }),
    );
  };

  export const generateAgingSummaryExcel = data => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [FETCH_AGING_REPORT_REQUEST, FETCH_AGING_REPORT_SUCCESS, FETCH_AGING_REPORT_ERROR],
        callAPI: () => ApiClient.post('payment/AgingReport/AgingReportSummaryExcel', data),
        payload: { data },
      }),
    );
  };

  export const getAgingReportDetail = id => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [FETCH_AGING_REPORT_DETAILS_REQUEST, FETCH_AGING_REPORT_DETAILS_SUCCESS, FETCH_AGING_REPORT_DETAILS_ERROR],
        callAPI: () => ApiClient.get(`payment/AgingReport/AgingReportDetails?state=admin&customerId=${id}`),
        payload: { data: { id } },
      }),
    );
  };

  export const generateAgingReportPdf = id => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [GENERATE_INVOICE_PDF_REQUEST, GENERATE_INVOICE_PDF_SUCCESS, GENERATE_INVOICE_PDF_ERROR],
        callAPI: () => ApiClient.post(`payment/AgingReport/CreateAgingReportPDF/?customerId=${id}`),
        payload: { data: { id } },
      }),
    );
  };

  const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
  };

  export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
      case FETCH_AGING_REPORT_REQUEST:
      case FETCH_AGING_REPORT_DETAILS_REQUEST:
        return {
          ...state,
          payload,
          response: {},
          error: {},
          successMessage: '',
          errorMessage: '',
        };
  
      case FETCH_AGING_REPORT_SUCCESS:
        return {
          ...state,
          data: {
            ...state.data,
            items: response.data.data.items,
            pages: response.data.data.pageCount,
          },
          response,
          successMessage,
        };

        case FETCH_AGING_REPORT_DETAILS_SUCCESS:
          return {
            ...state,
            data: {
              ...state.data,
              item: response.data.data,
            },
            response,
            successMessage,
          };


      case FETCH_AGING_REPORT_DETAILS_ERROR:
      case FETCH_AGING_REPORT_ERROR:
        return {
          ...state,
          payload,
          error,
          errorMessage,
        };
      default:
        return state;
    }
  }